<template>
  <div>
    <Row>
      <Col :span="18">
      <table class="params-table">
        <tr v-for="item in pingkaData" :key="item.key">
          <td class="label">{{item.key}}：</td>
          <td>{{item.value}}</td>
        </tr>
      </table>
      </Col>
      <Col :span="6" class="text-right">
      <e-image fit="contain" style=" height: 80px;" src="static/daoka/pingka.png"
               :preview-src-list="['static/daoka/pingka.png']" />
      </Col>
    </Row>
    <!-- <Table :data="pingkaData" :columns="[
        { title: 'key', key: 'key', width: 200 },
        {
          title: 'value',
          key: 'value',
          render: (h, params) => {
            return tableFmt(h, params, 'value');
          }
        }
      ]" style="width: 100%" :show-header="false">
    </Table> -->
  </div>
</template>

<script>
import { PackageInfo } from '@/utils/mixins'
export default {
  mixins: [PackageInfo],
  inject: {
    zhixiangData: {
      default: () => ({})
    }
  },
  data () {
    return {
      pingkaData: [
        {
          key: '品名',
          value: '平卡'
        },
        {
          key: '规格',
          value: ''
        },
        {
          key: '数量',
          value: ''
        },
        {
          key: '材料',
          value: ''
        },
        {
          key: '楞型',
          value: ''
        },
        {
          key: '材料定量',
          value: ''
        },
        {
          key: '耐破强度',
          value: ''
        },
        {
          key: '边压强度',
          value: ''
        }
      ]
    }
  },
  created () {
    this.assignDaokaData(this.packageInfo)
  },
  methods: {
    assignDaokaData (info) {
      const daokaInfo = info.packageinfo.auxiliary || {}
      const heavyDaokaMaterial = info.packageinfo.auxiliary.heavyDaokaMaterial || {}

      // 平卡
      this.pingkaData[1].value = `${daokaInfo.pingkaLong ||
        '---'} * ${daokaInfo.pingkaWidth || '---'} mm`
      this.pingkaData[2].value = daokaInfo.pingkaAmount
      this.pingkaData[3].value = heavyDaokaMaterial.materialtypeName
      this.pingkaData[4].value = heavyDaokaMaterial.lengxing + '楞'
      this.pingkaData[5].value = heavyDaokaMaterial.cailiaodingliang + 'g/m²'
      this.pingkaData[6].value = heavyDaokaMaterial.naipoqiangdu + 'kpa'
      this.pingkaData[7].value = heavyDaokaMaterial.bianyaqiangdu + 'N/m'
    },
    tableFmt (h, params, key) {
      if (typeof params.row[key] === 'number') {
        return h('span', params.row[key])
      }
      return h('span', params.row[key] || '---')
    },
    updateData () {
      this.assignDaokaData(this.packageInfo)
    }
  }

}
</script>

<style lang="scss" scoped></style>
